import React from "react";

const styles = require("./styles/footer.module.scss");

export const Footer = () => (
  <div className={styles.footer}>
    <span className={styles.footerText} />
  </div>
);
